import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { ServiceList } from '../serviceList/ServiceSelectList';
import { ServiceDetailsPage } from '../serviceDetailsPage/serviceDetailsPage';
import { baseUrl } from '../../../../network/constants/constants';
import config, { getConfig } from '../../../../network/auth';
import axios from '../../../../network/api';
import AppConstants from '../../../AppConstants';


const MainServices = () => {
  const [currentPage, setCurrentPage] = useState("service");
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);


  const config = useMemo(() => {
    return getConfig()
  },[])


  let bID = localStorage.getItem(AppConstants.business_id);

  const handlePageChange = (page, service_Id = null) => {
    setCurrentPage(page);
    setSelectedServiceId(service_Id);
  };

  const fetchCategory = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/categories-by-business/${bID}/`, config)
      .then((response) => {
        setLoading(false);
        setCategoryList(response.data);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };

  const fetchServices = useCallback((categoryId) => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/services/category/${categoryId}/`, config)
      .then((response) => {
        setLoading(false);
        setServiceList(response.data);
      })
      .catch((error) => {
        console.error("Service Error:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchCategory();
  }, []);

 

  return (
    <div>
      {currentPage === "service" && <ServiceList onPageChange={handlePageChange} categoryList={categoryList} serviceList={serviceList} fetchServices={fetchServices} setServiceList={setServiceList} />}
      {currentPage === "sub_service" && (
        <ServiceDetailsPage onPageChange={handlePageChange} service_id={selectedServiceId} fetchServices={fetchServices} serviceList={serviceList} />
      )}
    </div>
  );
};

export default MainServices;
